export var FormTypes;
(function (FormTypes) {
    FormTypes["WHATSAPP_CONTACT"] = "WHATSAPP_CONTACT";
    FormTypes["EMAIL"] = "EMAIL";
    FormTypes["PRECHAT"] = "PRE_CHAT";
    FormTypes["CONTACT_DETAILS"] = "CONTACT_DETAILS";
})(FormTypes || (FormTypes = {}));
export var ElementType;
(function (ElementType) {
    ElementType["INPUT_TEXT"] = "INPUT-TEXT";
    ElementType["TEXTAREA"] = "TEXTAREA";
    ElementType["TEXT_FIELD"] = "TEXT_FIELD";
    ElementType["SELECT"] = "SELECT";
    ElementType["FILE_UPLOAD"] = "FILE_UPLOAD";
    ElementType["SUBMIT"] = "SUBMIT";
    ElementType["DISMISS"] = "DISMISS";
    ElementType["SUBMIT_MESSAGE_SLOT"] = "SUBMIT-MESSAGE-SLOT";
})(ElementType || (ElementType = {}));
export var ElementDataType;
(function (ElementDataType) {
    ElementDataType["EMAIL"] = "EMAIL";
    ElementDataType["PHONE"] = "PHONE";
    ElementDataType["TEXT"] = "TEXT";
    ElementDataType["NUMBER"] = "NUMBER";
    ElementDataType["LABEL"] = "LABEL";
    ElementDataType["FILE"] = "FILE";
})(ElementDataType || (ElementDataType = {}));
